import _ from '@lodash';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';

const HtmlTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: '#333',
        color: '#fff',
        maxWidth: 500,
        margin: "8px 0",
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        zIndex: 1000
    },
}))(Tooltip);

class XAPPTooltip extends XAPPComponent {

    render() {
        const { children, title, placement, color } = this.props;

        return (
            <HtmlTooltip
                title={title}
                placement={placement}
                cor={!_.isUndefined(color) ? color : "#333"}
            >
                {children}
            </HtmlTooltip>
        )
    }
}


export default XAPPTooltip;
